import styled from 'styled-components'
import { Wrapper } from '@/components/VoucherSelector.styles'
import { BREAKPOINT_SMALL } from '@big-red-group/storefront-common-ui'

export const BookingWrapper = styled.div`
  padding: 48px 32px;
  background-color: var(--bg-lighttint);
  border-radius: 4px;
  ${Wrapper} {
    padding: 0px;
    left: -30px;
    background: transparent;
  }

  @media (max-width: ${BREAKPOINT_SMALL}px) {
    padding: 30px 30px 20px 30px;
    width: 100vw;
    position: relative;
    left: -25px;
    box-sizing: border-box;
    ${Wrapper} {
      padding: 0 30px;
    }
  }
`
